import React from "react"
import { BrowserRouter, Route, Switch } from "react-router-dom"
import { NavTabsProps } from "components/Shared/NavTabs/interfaces"
import NavTabsContent from "components/Shared/NavTabs/NavTabsContent"
import "./index.scss"

const NavTabs: React.FC<Omit<NavTabsProps, "title">> = ({ tabs }) => {
	return (
		<BrowserRouter>
			<Switch>
				<Route path="/">
					<NavTabsContent tabs={tabs} />
				</Route>
			</Switch>
		</BrowserRouter>
	)
}

export default NavTabs
